var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-prompt",
    {
      attrs: {
        "vs-title": "Edit Task",
        "vs-accept-text": "Submit",
        "vs-cancel-text": "Remove",
        "vs-button-cancel": "border",
        "vs-is-valid": _vm.validateForm,
        "vs-active": _vm.activePrompt,
      },
      on: {
        "vs-cancel": _vm.removeTodo,
        "vs-accept": _vm.submitTodo,
        "vs-close": _vm.init,
        "update:vsActive": function ($event) {
          _vm.activePrompt = $event
        },
        "update:vs-active": function ($event) {
          _vm.activePrompt = $event
        },
      },
    },
    [
      _c("div", [
        _c("form", [
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-1/6 self-center" },
              [
                _c("vs-checkbox", {
                  staticClass: "w-8",
                  model: {
                    value: _vm.isDoneLocal,
                    callback: function ($$v) {
                      _vm.isDoneLocal = $$v
                    },
                    expression: "isDoneLocal",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col ml-auto flex" },
              [
                _c("feather-icon", {
                  staticClass: "cursor-pointer",
                  attrs: {
                    icon: "InfoIcon",
                    svgClasses: [
                      { "text-success stroke-current": _vm.isImportantLocal },
                      "w-5",
                      "h-5 mr-4",
                    ],
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleIsImportant.apply(null, arguments)
                    },
                  },
                }),
                _c("feather-icon", {
                  staticClass: "cursor-pointer",
                  attrs: {
                    icon: "StarIcon",
                    svgClasses: [
                      { "text-warning stroke-current": _vm.isStarredLocal },
                      "w-5",
                      "h-5 mr-4",
                    ],
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleIsStarred.apply(null, arguments)
                    },
                  },
                }),
                _c(
                  "vs-dropdown",
                  {
                    staticClass: "cursor-pointer",
                    attrs: { "vs-custom-content": "" },
                  },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "TagIcon", svgClasses: "h-5 w-5" },
                    }),
                    _c(
                      "vs-dropdown-menu",
                      { staticStyle: { "z-index": "200001" } },
                      _vm._l(_vm.todoTags, function (tag, index) {
                        return _c(
                          "vs-dropdown-item",
                          { key: index },
                          [
                            _c(
                              "vs-checkbox",
                              {
                                attrs: { "vs-value": tag.value },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                                model: {
                                  value: _vm.tagsLocal,
                                  callback: function ($$v) {
                                    _vm.tagsLocal = $$v
                                  },
                                  expression: "tagsLocal",
                                },
                              },
                              [_vm._v(_vm._s(tag.text))]
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  staticClass: "w-full mb-4 mt-5",
                  attrs: { name: "title", placeholder: "Title" },
                  model: {
                    value: _vm.titleLocal,
                    callback: function ($$v) {
                      _vm.titleLocal = $$v
                    },
                    expression: "titleLocal",
                  },
                }),
                _c("vs-textarea", {
                  attrs: { rows: "5", label: "Add description" },
                  model: {
                    value: _vm.descLocal,
                    callback: function ($$v) {
                      _vm.descLocal = $$v
                    },
                    expression: "descLocal",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }